import React from 'react';
import { useReducer } from 'react';
import { useContext } from 'react';
import { usePrematchData } from '../PrematchDataFetcher';

const FavoriteTournamentsContext = React.createContext(null);
const FavoriteTournamentsDispatchContext = React.createContext(null);

export function useFavoriteTournaments() {
    return useContext(FavoriteTournamentsContext);
}

export function useFavoriteTournamentsDispatch() {
    return useContext(FavoriteTournamentsDispatchContext);
}

export function getFavoriteTournaments(prematchData) {
    let favorites = localStorage.getItem('favorite_tournaments');
    if (favorites != null) {
        favorites = JSON.parse(favorites);
        // Find the tournaments that are not present in the prematch data, if any
        const toRemove = [];
        Object.keys(favorites).forEach(f => {
            if (prematchData.tournamentByUniqueId[f] === undefined) {
                toRemove.push(f);
            }
        });
        if (toRemove.length > 0) {
            // Remove the expired tournaments
            toRemove.forEach(t => {
                delete favorites[t];
            });
            // // Set the new list in the local storage or remove the item altogether
            // if (Object.keys(favorites).length > 0) {
            //     localStorage.setItem('favorite_tournaments', JSON.stringify(favorites));
            // } else {
            //     localStorage.removeItem('favorite_tournaments');
            // }
        }
        return favorites;
    } else {
        return {};
    }
}

function saveFavoriteTournamentsToLS(key, favorites) {
    if (Object.values(favorites).length > 0) {
        localStorage.setItem(key, JSON.stringify(favorites));
    } else {
        localStorage.removeItem(key);
    }
}

function favoritesReducer(favorites, action) {
    switch (action.type) {
        case 'toggle': {
            if (favorites[action.id] === undefined) {
                favorites[action.id] = true;
            } else {
                delete favorites[action.id];
            }
            saveFavoriteTournamentsToLS('favorite_tournaments', favorites);
            return {...favorites};
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
}

export default function FavoriteTournamentsProvider(props) {
    const prematchData = usePrematchData();
    const [favorites, dispatch] = useReducer(
        favoritesReducer,
        getFavoriteTournaments(prematchData)
    );

    return (
        <FavoriteTournamentsContext.Provider value={favorites}>
            <FavoriteTournamentsDispatchContext.Provider value={dispatch}>
                {props.children}
            </FavoriteTournamentsDispatchContext.Provider>
        </FavoriteTournamentsContext.Provider>
    );
}
